import { useNotifications } from "../../Shared/Hooks/useNotifications";

const WebSocketInitializer =
  () => {

  useNotifications();

  return null;
};

export default WebSocketInitializer;